import React from 'react';
import { Link } from 'react-router-dom';
import { GlowingWrapper } from './GlowingEffect/GlowingWrapper';

/**
 * GeneralBox - A reusable box component for displaying services or tools
 * 
 * @param {string} title - The title of the box
 * @param {string} link - The link to navigate to when clicked
 * @param {string} imageSrc - The source of the image to display
 * @param {string} description - Optional description text
 * @param {boolean} useGlow - Whether to use the glowing effect (default: true)
 * @param {string} className - Additional CSS classes to apply
 * @param {ReactNode} customContent - Optional custom content to render inside the box
 * @param {Object} glowProps - Optional properties to customize the glowing effect
 */
export function GeneralBox({ 
  title, 
  link, 
  imageSrc, 
  description = '', 
  useGlow = true,
  className = '',
  customContent = null,
  glowProps = {}
}) {
  const boxContent = (
    <div 
      className={`general-box ${className}`}
    >
      <div className="box-title">
        <h2>{title}</h2>
      </div>
      
      {imageSrc && (
        <div className="box-icon">
          <div className="logo-container">
            <img src={imageSrc} alt={`${title} Logo`} className="box-logo" />
          </div>
        </div>
      )}
      
      {description && (
        <div className="box-description">
          <p>{description}</p>
        </div>
      )}
      
      {customContent && (
        <div className="box-custom-content">
          {customContent}
        </div>
      )}
    </div>
  );

  return (
    <Link 
      to={link} 
      className="box-link" 
      style={{ display: 'block', height: '100%' }}
    >
      {useGlow ? (
        <GlowingWrapper className={`${className}-wrapper`} glowProps={glowProps}>
          {boxContent}
        </GlowingWrapper>
      ) : (
        boxContent
      )}
    </Link>
  );
} 